import {ref, type Raw} from 'vue';
import {useRoute, useRouter, type TypedRoute, type TypedRouteFromName} from '@typed-router';
import {defineStore} from 'pinia';

/**
 * Fallback router to use in Pinia as Pinia can't watch route when it changes
 */
export const useRouterStore = defineStore('router-store', () => {
    const router = ref<Raw<ReturnType<typeof useRouter>>>(useRouter());
    const route = ref<TypedRoute | TypedRouteFromName<any>>(useRoute());

    return {
        router,
        route,
    };
});
